export default {
  error: {
    trace: 'Trace: {n}',
    api: {
      response: 'There was a problem with the server response'
    },
    pin: {
      'INVALID-PIN-LENGTH': 'PIN was not the correct length',
      'INVALID-PIN': 'An invalid PIN was supplied',
      'NO-TRANSACTION-DATA': 'No transaction data available for PIN',
      'NO-ACCOUNT': 'An invalid PIN was supplied (Error: 1)',
      'NO-BRANCH': 'An invalid PIN was supplied (Error: 2)',
      'NO-COMPANY': 'An invalid PIN was supplied (Error: 3)'
    },
    tableNumber: {
      'INVALID-PIN-LENGTH': 'Table number was not the correct length',
      'INVALID-PIN': 'An invalid table number was supplied',
      'NO-TRANSACTION-DATA': 'No transaction data available for table number',
      'NO-ACCOUNT': 'An invalid table number was supplied (Error: 1)',
      'NO-BRANCH': 'An invalid table number was supplied (Error: 2)',
      'NO-COMPANY': 'An invalid table number was supplied (Error: 3)'
    }
  }
};